import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import * as firebase from "firebase";
import './plugins/vue-kanban'
// import * as Sentry from '@sentry/browser';
// import { Vue as VueIntegration } from '@sentry/integrations';

Vue.config.productionTip = false;
Vue.config.devtools = true;
// the calendar component is giving this error - hiding it from console cos its annoying
const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.';
Vue.config.warnHandler = function (msg, vm, trace) {
  trace; vm;
  // `trace` is the component hierarchy trace
  if (msg === ignoreWarnMessage) {
    msg = null;
    vm = null;
    trace = null;
  }
}

const configOptions = {
  apiKey: "AIzaSyA-9XXtGuNdhMr4sBmO1kUnkAvCZBRIHt8",
  authDomain: "x-m-works.firebaseapp.com",
  databaseURL: "https://x-m-works.firebaseio.com",
  projectId: "x-m-works",
  storageBucket: "x-m-works.appspot.com",
  messagingSenderId: "545995409500",
  appId: "1:545995409500:web:6f69eddc8398079d307e99",
  measurementId: "G-KRHGCF34FH"
};

firebase.initializeApp(configOptions);


// Sentry.init({
//   dsn: 'https://feacd2c74f014108abf268c426032665@o397452.ingest.sentry.io/5251917',
//   integrations: [new VueIntegration({Vue, attachProps: true})],
// });

import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

Vue.use(VueMoment, {
  moment,
})


new Vue({
  router,
  store,
  vuetify,
  render: function (h) { return h(App) }
}).$mount('#app')
